import { defineStore } from 'pinia';

// Reuse the SortMeta interface
export interface SortMeta {
  field: string;
  order: number;
}

export const useTableSortStateStore = defineStore('tableSortState', {
  state: (): { sortOrders: Record<string, SortMeta[]> } => ({
    sortOrders: {},
  }),
  actions: {
    setSortOrder(dataKey: string, sortMeta: SortMeta[]) {
      this.sortOrders[dataKey] = sortMeta;
    },
    getSortOrder(dataKey: string): SortMeta[] {
      const order = this.sortOrders[dataKey] || [];
      return order;
    },
  },
  persist: {
    storage: localStorage,
  },
});
